/* RK ship-by / "we'll post it by" estimator.
 *
 * Made-to-order turnaround, shown on the cart drawer, /cart page, product page,
 * and (mirrored) the checkout extension. Rules (from Oscar, 2026-07-07):
 *   - Standard turnaround = 10 business days. Rush = 5 business days.
 *   - Business days only: skip weekends AND VIC public holidays (list below).
 *   - Midday cutoff (Melbourne time): an order placed BEFORE 12:00 on a business
 *     day counts today as day 1; at/after 12:00 (or on a weekend/holiday) the
 *     next business day is day 1.
 *   - "day 1 = start" is inclusive, so the posted-by date is the Nth business
 *     day (standard: start + 9 biz days; rush: start + 4 biz days).
 *
 * IMPORTANT: this exact logic is duplicated in the customiser bundle
 * (worker/src/customiser/shipBy.ts) and the checkout extension
 * (extensions/checkout-ship-by). If you change the day-counts, the cutoff, or
 * the holiday list, change it in all three.
 */
(function () {
  "use strict";
  if (window.RKShipBy) return;

  var STD_DAYS = 10;
  var RUSH_DAYS = 5;
  var CUTOFF_HOUR = 12; // midday, Melbourne
  var TZ = "Australia/Melbourne";

  // VIC public holidays that fall on a WEEKDAY (weekend ones are already
  // skipped). Keyed "YYYY-M-D" (month + day NOT zero-padded).
  var HOLIDAYS = {
    "2026-1-1": 1,   // New Year's Day
    "2026-1-26": 1,  // Australia Day
    "2026-3-9": 1,   // Labour Day
    "2026-4-3": 1,   // Good Friday
    "2026-4-6": 1,   // Easter Monday
    "2026-6-8": 1,   // King's Birthday
    "2026-9-25": 1,  // AFL Grand Final Friday (provisional)
    "2026-11-3": 1,  // Melbourne Cup
    "2026-12-25": 1, // Christmas Day
    "2026-12-28": 1, // Boxing Day observed
    "2027-1-1": 1,   // New Year's Day
    "2027-1-26": 1   // Australia Day
  };

  function isBiz(y, m, d) {
    var dow = new Date(Date.UTC(y, m - 1, d)).getUTCDay(); // 0 Sun .. 6 Sat
    if (dow === 0 || dow === 6) return false;
    if (HOLIDAYS[y + "-" + m + "-" + d]) return false;
    return true;
  }

  function addCal(y, m, d, n) {
    var dt = new Date(Date.UTC(y, m - 1, d + n));
    return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate() };
  }

  function nextBiz(c) {
    var x = addCal(c.y, c.m, c.d, 1);
    while (!isBiz(x.y, x.m, x.d)) x = addCal(x.y, x.m, x.d, 1);
    return x;
  }

  // "now" split into Melbourne wall-clock parts.
  function melbNow() {
    try {
      var parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: TZ, year: "numeric", month: "numeric", day: "numeric",
        hour: "numeric", hour12: false
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { if (p.type !== "literal") o[p.type] = parseInt(p.value, 10); });
      // hour "24" at midnight in some engines -> normalise to 0
      var hour = o.hour === 24 ? 0 : o.hour;
      return { y: o.year, m: o.month, d: o.day, hour: hour };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), hour: n.getHours() };
    }
  }

  var WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var MO = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  function fmt(c) {
    // "Fri 18 Jul" - built manually so the label is identical across engines
    // (locale patterns otherwise add commas / long month names).
    var dow = new Date(Date.UTC(c.y, c.m - 1, c.d)).getUTCDay();
    return WD[dow] + " " + c.d + " " + MO[c.m - 1];
  }

  // mode: "rush" | "standard" (default). Returns { mode, label, iso }.
  function compute(mode) {
    var now = melbNow();
    var start;
    if (isBiz(now.y, now.m, now.d) && now.hour < CUTOFF_HOUR) {
      start = { y: now.y, m: now.m, d: now.d };
    } else {
      start = nextBiz(now);
    }
    var n = mode === "rush" ? RUSH_DAYS : STD_DAYS;
    var cur = start, count = 1;
    while (count < n) { cur = nextBiz(cur); count++; }
    var iso = cur.y + "-" + ("0" + cur.m).slice(-2) + "-" + ("0" + cur.d).slice(-2);
    return { mode: mode === "rush" ? "rush" : "standard", label: fmt(cur), iso: iso };
  }

  window.RKShipBy = { compute: compute, STD_DAYS: STD_DAYS, RUSH_DAYS: RUSH_DAYS };
})();
